const eligibilityOfRPDummy = {
  statusCode: 200,
  jsonResult: {
    eligibility: false,
    reason: "TAKEN",
  },
};

export default eligibilityOfRPDummy;
